<template>
  <el-scrollbar>
    <el-row class="tac">
      <el-col :span="24">
        <el-menu :default-active="defaultActive" :unique-opened="true" :router="true"
                 :default-openeds="openMenus"
                 class="el-menu-vertical-demo"
                 @open="handleOpen"
                 @close="handleClose">
          <template v-for="(item,index) in sliders" v-key="index">
            <el-submenu :index="item.name+item.pagePath"
                        v-if="item.subSliders&&item.subSliders.length>0">
              <template slot="title">
                <i :class="'iconfont '+ item.iconClass"></i>
                <span>{{ item.name }}</span>
              </template>
              <el-menu-item-group v-if="item.subSliders&&item.subSliders.length>0">
                <a :href="href(subItem)"
                   v-for="(subItem,subIndex) in item.subSliders">
                  <el-menu-item :index="subItem.name+subItem.pagePath">
                    {{ subItem.name }}
                  </el-menu-item>
                </a>
              </el-menu-item-group>
            </el-submenu>
            <a :href="href(item)" v-else>
              <el-menu-item :index="item.name+item.pagePath">
                <template slot="title">
                  <i :class="'iconfont '+ item.iconClass"></i>
                  <span>{{ item.name }}</span>
                </template>
              </el-menu-item>
            </a>
          </template>
        </el-menu>
      </el-col>
    </el-row>
  </el-scrollbar>
</template>
<script>
import {config} from "../common/config";

export default {
  name: "sidebar",
  data() {
    return {
      sidebarOpen: true,
      domain: process.env.VUE_APP_DOMAIN,
      defaultActive: '',
      openMenus: [],
      "sliders": [
        {
          "name": '首页',
          "pagePath": 'index.html',
          "iconClass": 'icon-dashboard',
          "subSliders": []
        },
        {
          "name": '淘客设置',
          "pagePath": '',
          "iconClass": 'icon-tao',
          "subSliders": [
            {
              "name": '高佣授权',
              "pagePath": 'highcommission_settings.html'
            },
            {
              "name": '多联盟账号',
              "pagePath": 'taobao_auth_config.html',
              "new": true
            },
            {
              "name": '淘口令设置',
              "pagePath": 'taotoken_settings.html'
            }
          ]
        },
        {
          "name": '拼多多设置',
          "pagePath": '',
          "iconClass": 'icon-pinduoduo',
          "subSliders": [
            {
              "name": '高佣授权',
              "pagePath": 'pdd_highcommission_settings.html'
            },
            {
              "name": '通用设置',
              "pagePath": 'pdd_other_settings.html'
            },
          ]
        },
        {
          "name": '京东设置',
          "pagePath": '',
          "iconClass": 'icon-jingdong',
          "subSliders": [
            {
              "name": '高佣授权',
              "pagePath": 'jd_highcommission_settings.html'
            }
          ]
        },
        {
          "name": '唯品会设置',
          "pagePath": '',
          "iconClass": 'icon-weipinhui',
          "subSliders": [
            {
              "name": '高佣授权',
              "pagePath": 'vip_highcommission_settings.html'
            }
          ]
        },
        {
          "name": '抖音设置',
          "pagePath": '',
          "iconClass": 'icon-douyin',
          "subSliders": [
            {
              "name": '高佣授权',
              "pagePath": 'douyin_highcommission_settings.html'
            }
          ]
        },
        {
          "name": '滴滴设置',
          "pagePath": '',
          "iconClass": 'icon-didichuhang',
          "subSliders": [
            {
              "name": '滴滴联盟',
              "pagePath": 'didi_config.html',
              "new": true
            }
          ]
        },
        {
          "name": '微信小程序',
          "pagePath": '',
          "iconClass": 'icon-xiaochengxu',
          "subSliders": [
            {
              "name": '基础设置',
              "pagePath": 'app_settings.html'
            },
            {
              "name": '小程序更换',
              "pagePath": 'app_change.html'
            },
            {
              "name": '通用设置',
              "pagePath": 'other_settings.html'
            },
            {
              "name": '订阅消息',
              "pagePath": 'mini_program_template_message.html'
            },
            {
              "name": '导购设置',
              "pagePath": 'chat_settings.html',
              "new": true
            }
          ]
        },
        {
          "name": '支付宝小程序',
          "pagePath": '',
          "iconClass": 'icon-alipay',
          "subSliders": [
            {
              "name": '基础设置',
              "pagePath": 'alipay_app_settings.html',
            }
          ]
        },
        {
          "name": '活码系统',
          "pagePath": '',
          "iconClass": 'icon-erweima2',
          "subSliders": [
            {
              "name": '公众号活码',
              "pagePath": 'mp_media_activity.html',
              "new": true
            },
            {
              "name": '小程序活码',
              "pagePath": 'xcx_media_activity.html',
              "new": true
            }
          ]
        },
        {
          "name": '外卖系统',
          "pagePath": '',
          "iconClass": 'icon-waimai-',
          "subSliders": [
            {
              "name": '饿了么',
              "pagePath": 'ele.html',
              "new": true
            },
            {
              "name": '美团',
              "pagePath": 'meituan.html',
              "new": true
            }
          ]
        },
        {
          "name": '营销管理',
          "pagePath": '',
          "iconClass": 'icon-yingxiao',
          "subSliders": [
            {
              "name": '积分规则',
              "pagePath": 'point_rules.html'
            },
            {
              "name": '积分设置',
              "pagePath": 'point_settings.html'
            },
            /*{
                "name": '积分商品',
                "pagePath": 'point_products.html'
            },*/
            {
              "name": '用户积分',
              "pagePath": 'user_point.html',
              "new": true
            },
            {
              "name": '积分兑换',
              "pagePath": 'exchange_settings.html'
            },
            {
              "name": '裂变活动',
              "pagePath": 'invite_activity.html',
              "new": true

            },
            {
              "name": 'AI模型',
              "pagePath": 'llm_config.html',
              "new": true

            },
            {
              "name": '专题商品',
              "pagePath": 'user_products.html',
              "new": true,
            },
            {
              "name": '红包奖励',
              "pagePath": 'new_bonus.html',
              "new": true
            },
            {
              "name": '淘礼金',
              "pagePath": 'taoke_tools.html',
              "new": true
            },
            {
              "name": '京享礼金',
              "pagePath": 'jd_lijin.html',
              "new": true
            },
            {
              "name": '首单礼金',
              "pagePath": 'sdlj.html',
              "new": true
            },
            {
              "name": '拼多多',
              "pagePath": 'pdd_tools.html',
              "new": true
            }

          ]
        },
        {
          "name": '返利管理',
          "pagePath": '',
          "iconClass": 'icon-fanli',
          "subSliders": [
            {
              "name": '提现管理',
              "pagePath": 'withdraw_center.html',
              "new": true
            },
            {
              "name": '返利订单',
              "pagePath": 'rebate_orders.html'
            },
            {
              "name": '用户关系',
              "pagePath": 'rebate_users.html'
            },
            {
              "name": '规则设置',
              "pagePath": 'rebate_settings.html',
              "new": true
            },
            {
              "name": '级别设置',
              "pagePath": 'user_rebate_level.html',
              "new": true
            },
            {
              "name": '店铺黑名单',
              "pagePath": 'shop_black_list.html',
              "new": true
            },
            {
              "name": '用户黑名单',
              "pagePath": 'user_black_list.html',
              "new": true
            },
            {
              "name": '订单处理',
              "pagePath": 'rebate_orders_settings.html'
            },
            {
              "name": 'Pid管理',
              "pagePath": 'taoke_pid.html',
              "new": true

            },
            {
              "name": '好物官',
              "pagePath": 'rebate_agent_manage.html',
              "new": true
            },
            {
              "name": '用户报表',
              "pagePath": 'user_report.html',
              "new": true
            },
            {
              "name": '利润报表',
              "pagePath": 'profit_report.html',
              "new": true
            }


          ]
        },
        {
          "name": '订单管理',
          "pagePath": '',
          "iconClass": 'icon-dingdan',
          "subSliders": [
            {
              "name": '订单管理',
              "pagePath": 'order_manage.html',
              "new": true
            },
            {
              "name": '订单同步',
              "pagePath": 'order_sync.html',
              "new": true
            }
          ]
        },
        {
          "name": '用户管理',
          "pagePath": '',
          "iconClass": 'icon-iconfont-yonghu',
          "subSliders": [
            {
              "name": '用户管理',
              "pagePath": 'user_manage.html',
              "new": true
            }
          ]
        },
        {
          "name": '公众号管理',
          "pagePath": '',
          "iconClass": 'icon-gongzhonghao',
          "subSliders": [
            {
              "name": '菜单设置',
              "pagePath": 'wx_menu.html'
            },
            {
              "name": '导购设置',
              "pagePath": 'mp_buy_guide.html'
            },
            {
              "name": '自动回复',
              "pagePath": 'mp_autoreply.html'
            },
            {
              "name": '模板消息',
              "pagePath": 'mp_template_message.html'
            },
            {
              "name": '授权管理',
              "pagePath": 'mp_auth.html'
            },
            {
              "name": '支付设置',
              "pagePath": 'wechat_pay_settings.html'
            },
            {
              "name": '安全设置',
              "pagePath": 'security_settings.html',
              "new": true
            },
            {
              "name": '其它设置',
              "pagePath": 'mp_other_settings.html',
              "new": true
            },
            {
              "name": '引导关注',
              "pagePath": 'show_ggh.html',
              "new": true
            },
          ]
        },
        {
          "name": '微信群管理',
          "pagePath": '',
          "iconClass": 'icon-weixinqun',
          "subSliders": [
            {
              "name": '微信群管理',
              "pagePath": 'wechat_group_settings.html'
            }
          ]
        },
        {
          "name": '代理管理',
          "pagePath": '',
          "iconClass": 'icon-daili',
          "subSliders": [
            {
              "name": '代理申请',
              "pagePath": 'agent_waiting_settings.html'
            },
            {
              "name": '代理管理',
              "pagePath": 'agent_settings.html'
            },
            {
              "name": '分成比例',
              "pagePath": 'agent_commission_settings.html'
            },
            {
              "name": '海报设置',
              "pagePath": 'partner_settings.html'
            },
          ]
        },
        {
          "name": '发单管理',
          "pagePath": '',
          "iconClass": 'icon-fasong',
          "subSliders": [
            {
              "name": '分组管理',
              "pagePath": 'wechat_auto_send_settings.html'
            },
            {
              "name": '发送池管理',
              "pagePath": 'product_pool_auto_send_settings.html'
            },
            {
              "name": '朋友圈管理',
              "pagePath": 'product_pool_moments.html'
            },
            {
              "name": '设备管理',
              "pagePath": 'send_devices_settings.html'
            },
            {
              "name": '通用设置',
              "pagePath": 'send_other_settings.html'
            },

          ]
        },
        {
          "name": '结算管理',
          "pagePath": '',
          "iconClass": 'icon-jiesuan',
          "subSliders": [
            {
              "name": '结算管理',
              "pagePath": 'settlement.html'
            }
          ]
        },
        {
          "name": '海报设置',
          "pagePath": '',
          "iconClass": 'icon-haibao',
          "subSliders": [
            {
              "name": '海报设置',
              "pagePath": 'share_poster.html'
            }
          ]
        },
        {
          "name": '界面设置',
          "pagePath": '',
          "iconClass": 'icon-jiemian',
          "subSliders": [
            {
              "name": '导航设置',
              "pagePath": 'nav_settings.html',
              "new": true
            },
            {
              "name": '轮播设置',
              "pagePath": 'banner_settings.html',
              "new": true
            },
            {
              "name": '海报设置',
              "pagePath": 'poster_settings.html',
              "new": true
            },
            {
              "name": '弹窗设置',
              "pagePath": 'popup_settings.html'
            },
            {
              "name": '主题设置',
              "pagePath": 'theme_config.html',
              "new": true
            },
            {
              "name": '活动设置',
              "pagePath": 'layout_settings.html',
              "new": true
            },
            {
              "name": '通知设置',
              "pagePath": 'notice_settings.html'
            },
            {
              "name": '提现规则',
              "pagePath": 'withdraw_rules.html',
              "new": true
            },
            {
              "name": '推广规则',
              "pagePath": 'promotion_rules.html',
              "new": true
            },
            {
              "name": '海报文案',
              "pagePath": 'poster_introduce.html',
              "new": true
            },
            {
              "name": '帮助设置',
              "pagePath": 'help_page.html',
              "new": true
            }
          ]
        },
        {
          "name": '分享设置',
          "pagePath": '',
          "iconClass": 'icon-fenxiang',
          "subSliders": [
            {
              "name": '首页设置',
              "pagePath": 'index_share_settings.html'
            },
            {
              "name": '个人中心设置',
              "pagePath": 'profile_share_settings.html'
            }

          ]
        },
        {
          "name": '客服设置',
          "pagePath": '',
          "iconClass": 'icon-kefu1',
          "subSliders": [
            {
              "name": '客服设置',
              "pagePath": 'customerService_settings.html'
            }

          ]
        },
        {
          "name": '开放页面',
          "pagePath": '',
          "iconClass": 'icon-kaifang',
          "subSliders": [
            {
              "name": '开放页面',
              "pagePath": 'open_pages.html'
            }

          ]
        },
        /*{
            "name": '推广赚钱',
            "pagePath": '',
            "iconClass": 'icon-closeaccount',
            "subSliders": [
                {
                    "name": '推广赚钱',
                    "pagePath": 'promotion.html'
                }

            ]
        },*/
        {
          "name": '发布管理',
          "pagePath": '',
          "iconClass": 'icon-fabu',
          "subSliders": [
            {
              "name": '发布管理',
              "pagePath": 'upgrade.html'
            }

          ]
        }


      ]

    }
  },
  mounted() {
    console.log(window.location.href)
    this.handleActive();
    this.$nextTick(() => {
      setTimeout(() => {
        const activeItem = this.$el.querySelector('.el-menu-item.is-active');
        if (activeItem) {
          activeItem.scrollIntoView({block: 'center', behavior: 'smooth'});
        }
      }, 500);
    })
  },
  methods: {
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    goPage(item) {
      window.location.href = '/' + item.pagePath;
    },
    handleActive() {
      console.log("handleActive")
      var currentPagePath = window.location.pathname;
      currentPagePath = currentPagePath.substring(currentPagePath.lastIndexOf("/") + 1)
      currentPagePath = currentPagePath + window.location.search;
      /* var pathEnd = currentPagePath.indexOf("?")
       if (pathEnd != -1) {
           currentPagePath = currentPagePath.substring(0, pathEnd);
       }*/
      for (var i = 0; i < this.sliders.length; i++) {
        var slider = this.sliders[i];
        var path = slider.pagePath;
        /* var end = path.indexOf("?");
         if (end !== -1) {
             path = path.substring(0, end)
         }*/
        if (slider.active) {
          slider.active = null
        }
        if (path === currentPagePath) {
          slider.active = 'active'
          this.defaultActive = slider.name + path
          //this.openMenus = [this.defaultActive];
          return
        }
        var subSliders = slider['subSliders'];
        for (var j = 0; j < subSliders.length; j++) {
          var subSlider = subSliders[j]
          path = subSlider.pagePath
          /*end = path.indexOf("?");
          if (end !== -1) {
              path = path.substring(0, end)
          }*/
          if (subSlider.active) {
            subSlider.active = null
          }
          if (path === currentPagePath) {
            subSlider.active = 'active'
            slider.active = 'active'
            this.defaultActive = subSlider.name + path
            //this.openMenus = [this.defaultActive];
            return
          }
        }
      }
      console.log("defaultActive" + this.defaultActive)
    },
    href(item) {
      console.log(config.envmode)
      console.log(config.domain)
      if (config.envmode === 'development') return '/' + item.pagePath;
      if (item.new) return this.domain + '/new/' + item.pagePath;
      return this.domain + '/' + item.pagePath;
    }

  }
}
</script>
<style lang="scss">


#app {

  .iconfont {
    width: 20px;
    height: 20px;
    font-size: 15px;
  }

  .el-menu {
    background-color: #2a3542;

    .el-menu-item-group__title {
      display: none;
    }

    .el-submenu .el-menu-item {
      height: 45px;
      line-height: 45px;
    }


    .el-submenu__title {
      color: #aeb2b7;
    }

    .el-submenu__title:hover, .el-submenu__title:focus {
      background: #35404d;
      color: #fff;
    }

    .el-submenu__title:hover i {
      color: $hover-color;
    }
  }

  .el-scrollbar {
    height: 100%;
  }

  .el-aside {
    height: 100%;
    width: 210px;
    position: fixed;
    left: 0;
    overflow: hidden;
    top: 60px;

    .el-menu {
      text-align: left;
      font-weight: 500;

    }

    .el-submenu {
      text-align: left;

    }

    .el-menu-item {
      color: #aeb2b7;

      i {
        margin-right: 6px;
      }

      vertical-align: middle;
    }

    .el-menu-item:hover, .el-menu-item:hover i {
      color: $hover-color;
      background: #35404d;
    }

    .el-submenu__title:hover {
      color: $hover-color;
    }

    .el-menu-item.is-active {
      border-left: 2px solid $hover-color;
      color: $hover-color;
    }

    .el-submenu__title i {
      margin-right: 6px;
    }
  }

  #main-content {
    margin-left: 210px;
    margin-top: 60px;
  }
}

</style>

